if (typeof (angular) !== "undefined") {
    angular.module("publicationListViewApp", []);

    angular.module("publicationListViewApp").controller("publicationListViewController", ["$scope", "$locale", "$http", function ($scope, $locale, $http) {

        //Rakentelee svg-ikonit kun ng-repeatin itemit renderöity
        $scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
            //replaceSvgIcons(); //--> scripts.js
        });

        //Parseroidaan apin palauttama päivämäärätieto
        $scope.itemDate = function (dateString) {
            if (typeof dateString !== "undefined" && dateString !== null) {
                var parsed = parseInt(dateString.replace(/[^0-9\-]/g, ''));
                return parsed < 0 ? "" : new Date(parsed);
            }
            else
                return "";
        };

        $scope.pdfTitle = function (item) {
            return item.DownloadTitle;
        }

        $scope.itemName = function (url) {
            var name = url;
            if (url != "") {
                name = url.substring(url.lastIndexOf('/') + 1);
                if (name.lastIndexOf('?') > 0) {
                    name = name.split('?')[0];
                }
            }
            return name;
        }

        //Tavut megatavuiksi
        $scope.itemSize = function (size) {
            if (typeof size !== "undefined" && size !== null && typeof size === "number")
                return (size / 1024 / 1024).toFixed(2);
            else
                return "";
        };

        //Palauttaa halutun otsikkokentän
        $scope.itemTitle = function (item) {
            if (useAltTitle && typeof item.AlternativeTitle !== "undefined" && item.AlternativeTitle !== null)
                return item.AlternativeTitle;
            else
                return item.Title.Text;
        };

        //Palauttaa muotoillun tekijälistan
        $scope.itemAuthors = function (item) {
            var str = "";
            for (var i = 0; i < item.Authors.length; i++) {
                str += (item.Authors[i].Name + (i < item.Authors.length - 1 ? "; " : ""));
            }

            if (item.Authors.length > 0){
                var year = $scope.itemDate(item.PublishDate);
                if (year != "")
                    str += " (" + year.getFullYear() + ")";
            }

            return str;
        };

        function getPages() {
            var pageNumbers = [];
            var pageAmount = $scope.publicationData.Hits / $scope.pagiAmount + ($scope.publicationData.Hits % $scope.pagiAmount != 0 ? 1 : 0);
            for (var i = 1; i <= pageAmount; i++) {
                pageNumbers.push(i);
            }
            return pageNumbers;
        };

        function getPagiSections() {
            return Math.floor($scope.pagiPages.length / $scope.pagiSectionSize) + ($scope.pagiPages.length % $scope.pagiSectionSize != 0 ? 1 : 0);
        }

        //Hakee halutun vuoden julkaisut, tukee sivutusta
        function getPublications(prid, amount, start, year) {
            $scope.loading = true;
            //iSpinner(true);
            var ApiUrl = "/api/publications/" + prid + "?amount=" + amount + "&start=" + start + "&year=" + year;
            //console.log(ApiUrl);

            $http.get(ApiUrl)
                .then(function successCallback(response) {
                    //console.log("OK: - " + response.data);
                    $scope.publicationData = response.data;
                    $scope.publicationDataValid = (typeof $scope.publicationData !== "undefined" && $scope.publicationData !== null);
                }, function errorCallback() {
                    $scope.publicationDataValid = false;
                    //console.log($scope.error);
                    $scope.error = true;
                }).then(function () {
                    $scope.loading = false;
                    if ($scope.publicationDataValid) {
                        $scope.pagiPages = getPages();
                        $scope.totalPagiSections = getPagiSections();
                        if (typeof $scope.publicationData.Publications !== "undefined" && $scope.publicationData.Publications !== null && (Object.keys($scope.publicationData.Publications).length > 0)) {
                            $scope.noResults = false;
                            //iSpinner(false);
                        } else {
                            $scope.noResults = true;
                            //iSpinner(false);
                        }
                    } else {
                        $scope.error = true;
                        console.log($scope.error);
                    }
                });
        };

        $scope.pagiHits = function () {
            if ($scope.publicationData.Hits < $scope.pagiAmount)
                return $scope.publicationData.Hits;
            if ($scope.pagiIndex + $scope.pagiAmount > $scope.publicationData.Hits)
                return $scope.publicationData.Hits;

            return $scope.pagiIndex + $scope.pagiAmount;
        };

        $scope.pagiChanged = function (pageNumber) {
            //iSpinner(true);
            $scope.pagiSelected = pageNumber;
            $scope.pagiIndex = (pageNumber - 1) * $scope.pagiAmount;

            $scope.selectedPagiSection = Math.floor(pageNumber / $scope.pagiSectionSize) + (pageNumber % $scope.pagiSectionSize != 0 ? 1 : 0);

            if ($scope.pagiIndex < 0)
                $scope.pagiIndex = 0;

            if ($scope.pagiIndex > $scope.publicationData.Hits)
                $scope.pagiIndex -= $scope.pagiAmount;

            getPublications(prid, $scope.pagiAmount, $scope.pagiIndex, $scope.selectedYear);
        };

        $scope.sectionChanged = function (sectionNumber) {
            if (sectionNumber < 1)
                $scope.selectedPagiSection = 1;
            else if (sectionNumber > $scope.totalPagiSections)
                $scope.selectedPagiSection = $scope.totalPagiSections;
            else
                $scope.selectedPagiSection = sectionNumber;

            $scope.pagiSelected = (($scope.selectedPagiSection - 1) * $scope.pagiSectionSize) + 1;
            $scope.pagiIndex = ($scope.pagiSelected - 1) * $scope.pagiAmount;

            getReports(rrid, $scope.pagiAmount, $scope.pagiIndex);
        }

        $scope.paginationFilter = function (page) {
            var value = page / $scope.pagiSectionSize;
            value = value % 1 == 0 ? value : Math.floor(value + 1);
            return (value == $scope.selectedPagiSection);
        }

        //Laukeaa kun vuosivalinta vaihtuu
        $scope.yearChanged = function () {
            //iSpinner(true);
            $scope.pagiIndex = 0;
            $scope.pagiSelected = 1;
            $scope.selectedPagiSection = 1;
            getPublications(prid, $scope.pagiAmount, $scope.pagiIndex, $scope.selectedYear);
        };

        //Haetaan filtterille tiedot ja ensimmäisen vuoden julkaisut
        function init() {
            if (typeof prid === 'number' && typeof pagiAmount === 'number' && typeof showPubDesc === "boolean" && typeof showPubDate === "boolean" && typeof useAltTitle === "boolean") {
                //Sivupropertyistä saatavat parametrit:
                $scope.pagiAmount = pagiAmount;
                $scope.showPubDate = showPubDate;
                $scope.showPubDesc = showPubDesc;
                $scope.useAltTitle = useAltTitle;
                $scope.swapFields = swapFields;

                //Filtteri- ja sivutusmuuttujat
                $scope.pagiSectionSize = 10;
                $scope.selectedPagiSection = 1;
                $scope.totalPagiSections;
                $scope.selectedYear;
                $scope.pagiIndex = 0;
                $scope.pagiSelected = 1;
                $scope.publicationData;
                $scope.filterData;

                $scope.loading = true;
                //iSpinner(true);
                console.log("/api/publications/filterdata/" + prid);

                $http.get("/api/publications/filterdata/" + prid)
                    .then(function successCallback(response) {
                        $scope.filterData = response.data;
                        $scope.filterDataValid = (typeof $scope.filterData !== "undefined" && $scope.filterData !== null);
                    }, function errorCallBack() {
                        $scope.filterDataValid = false;
                        $scope.error = true;
                    }).then(function () {
                        if ($scope.filterDataValid) {
                            if (typeof $scope.filterData.PublicationYears !== "undefined" && $scope.filterData.PublicationYears !== null && (Object.keys($scope.filterData.PublicationYears).length > 0) && typeof $scope.filterData.TotalHits !== "undefined" && $scope.filterData.TotalHits !== null && $scope.filterData.TotalHits > 0) {
                                $scope.selectedYear = $scope.filterData.PublicationYears[0];
                                getPublications(prid, $scope.pagiAmount, $scope.pagiIndex, $scope.selectedYear);
                                $scope.noItems = false;
                                //iSpinner(false);
                            } else {
                                $scope.loading = false;
                                $scope.noItems = true;
                                //iSpinner(false);
                            }
                        } else {
                            $scope.loading = false;
                            $scope.error = true;
                            //iSpinner(false);
                        }
                    });
            } else {
                $scope.error = true;
            }
        }

        //Datan validointi & virheviestit
        $scope.filterDataValid = false;
        $scope.publicationDataValid = false;
        $scope.loading = false;
        $scope.moreResults = false;
        $scope.noResults = false;
        $scope.noItems = false;
        $scope.error = false;

        init();

    }]);

    angular.module('publicationListViewApp').directive('onFinishRender', ["$timeout", function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attr) {
                if (scope.$last === true) {
                    $timeout(function () {
                    scope.$emit(attr.onFinishRender);
                });
            }
            }
        }
    }]);
};
